import { jsonParseReviver as reviver } from "../shared/api-client-extensions";

/**
 * The JSON.parse reviver the data clients apply to every datasource response:
 * "YYYY-MM-DD" strings become DateOnly instances, ISO date-time strings become Dates.
 */
export const jsonParseReviver = reviver;

/**
 * Deep variant of `jsonParseReviver` for values that were not parsed with the reviver attached
 * (e.g. hand-written test fixtures), so tests exercise production-shaped data.
 */
export const reviveDates = (value: unknown): unknown => {
    if (Array.isArray(value))
        return value.map(reviveDates);

    if (value !== null && typeof value === "object" && !(value instanceof Date))
        return Object.fromEntries(Object.entries(value).map(([key, entry]) => [key, reviveDates(entry)]));

    return jsonParseReviver("", value);
};
